/*
 * SereniVida MX — COD Coverage Validator + Releasit Variant Enforcer
 *
 * Reads Shopify-rendered whitelists from `window.CODCoverageData`
 * (populated inline by each theme layout so ad-blockers don't break it):
 *
 *   window.CODCoverageData = {
 *     codList: "12345,23456, ...",   // shop.metafields.custom.cps_tiui
 *     advA:    "34567,45678, ...",   // shop.metafields.custom.cps_anticipado
 *     advB:    "56789, ..."          // shop.metafields.custom.cps_anticipado2
 *   };
 *
 * Responsibilities
 * ----------------
 *  1) Toggle the visibility of the COD button (`._rsi-build-block-submit-button`)
 *     and the advance-payment buttons (`a._rsi-buy-now-custom-additionals-button`)
 *     based on the postal code the customer typed into the COD modal form.
 *
 *  2) When the customer's postal code has NO coverage at all (neither COD nor
 *     advance payment), render a friendly "sin cobertura" message below the
 *     ZIP input so they understand why no checkout option is shown.
 *
 *  3) Patch the Releasit Quantity Offers bundle block so that:
 *        a) No variant is pre-selected (every <select> gets a disabled
 *           "Selecciona <opción>" placeholder as its default).
 *        b) The COD / advance-payment buttons are blocked until every
 *           single variant selector inside the CURRENTLY SELECTED offer has
 *           a real value, including all additional pairs in bundled offers
 *           (e.g. 2x1, 3x2, 4x3). Missing selects are highlighted and a
 *           warning is shown.
 */
(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Coverage whitelists
  // ---------------------------------------------------------------------------

  function parseList(raw) {
    return new Set(
      (typeof raw === 'string' ? raw : '')
        .split(/[\r\n,]+/)
        .map(function (s) { return s.trim(); })
        .filter(function (s) { return s.length > 0; })
    );
  }

  var data = window.CODCoverageData || {};
  var codWhitelist      = parseList(data.codList);
  var advanceWhitelistA = parseList(data.advA);
  var advanceWhitelistB = parseList(data.advB);

  function inAdvance(zip) {
    return advanceWhitelistA.has(zip) || advanceWhitelistB.has(zip);
  }
  function advanceHasAny() {
    return advanceWhitelistA.size > 0 || advanceWhitelistB.size > 0;
  }

  function getCodButton() {
    return document.querySelector('._rsi-build-block-submit-button');
  }
  function getAdvanceButtons() {
    return document.querySelectorAll('a._rsi-buy-now-custom-additionals-button');
  }
  function getZipInput() {
    var el = document.querySelector('#_rsi-cod-form-modal-form input[data-type="zip_code"]');
    if (el) return el;
    el = document.querySelector('#_rsi-cod-form-modal-form [name*="zip"]');
    if (el) return el;
    return document.querySelector('#_rsi-cod-form-modal-form select[data-type="zip_country_field"]');
  }

  function showBtn(b) { if (b) b.style.setProperty('display', 'block', 'important'); }
  function hideBtn(b) { if (b) b.style.setProperty('display', 'none', 'important'); }
  function showEach(list) { for (var i = 0; i < list.length; i++) showBtn(list[i]); }
  function hideEach(list) { for (var i = 0; i < list.length; i++) hideBtn(list[i]); }

  // ---------------------------------------------------------------------------
  // Friendly "sin cobertura" message
  // ---------------------------------------------------------------------------

  var MSG_ID = '_cod-no-coverage-message';

  function ensureMessage() {
    var zipEl = getZipInput();
    if (!zipEl) return null;

    var msg = document.getElementById(MSG_ID);
    if (!msg) {
      msg = document.createElement('div');
      msg.id = MSG_ID;
      msg.setAttribute('role', 'status');
      msg.setAttribute('aria-live', 'polite');
      msg.style.cssText = [
        'display:none',
        'margin:14px 0',
        'padding:14px 16px',
        'border-radius:10px',
        'background:#fff4e5',
        'border:1px solid #ffb74d',
        'color:#7a4e00',
        'font-size:14px',
        'line-height:1.45',
        'text-align:center',
        'font-family:inherit'
      ].join(';');
      msg.innerHTML =
        '<strong>¡Lo sentimos!</strong><br>' +
        'Por el momento no contamos con cobertura de envío para tu código postal. ' +
        'Estamos trabajando para llegar pronto a tu zona. ' +
        'Si necesitas ayuda, por favor contáctanos.';
    }

    // Keep the message anchored right below the ZIP input's field container.
    var anchor = zipEl.closest('._rsi-modal-fields-item') || zipEl.parentElement;
    if (anchor && anchor.parentNode && msg.parentNode !== anchor.parentNode) {
      anchor.parentNode.insertBefore(msg, anchor.nextSibling);
    }
    return msg;
  }

  function showMsg() { var m = ensureMessage(); if (m) m.style.display = 'block'; }
  function hideMsg() { var m = ensureMessage(); if (m) m.style.display = 'none'; }

  function evaluateZip() {
    var codBtn  = getCodButton();
    var advBtns = getAdvanceButtons();
    if (!codBtn && (!advBtns || advBtns.length === 0)) return;

    var zipEl  = getZipInput();
    var zip    = zipEl ? (zipEl.value || '').trim() : '';
    var hasZip = !!zipEl && zip.length >= 5;

    var codConfigured = codWhitelist.size > 0;
    var advConfigured = advanceHasAny();
    var codInList     = codWhitelist.has(zip);
    var advInList     = inAdvance(zip);

    // --- COD button visibility ---
    var codVisible = false;
    if (codBtn) {
      if (!hasZip || !codConfigured || codInList) {
        showBtn(codBtn);
        codVisible = true;
      } else {
        hideBtn(codBtn);
      }
    }

    // --- Advance-payment buttons visibility ---
    var advVisible = false;
    if (advBtns && advBtns.length) {
      if (!hasZip || !advConfigured || advInList) {
        showEach(advBtns);
        advVisible = true;
      } else {
        hideEach(advBtns);
      }
    }

    // --- Friendly no-coverage notice ---
    if (hasZip && !codVisible && !advVisible && (codConfigured || advConfigured)) {
      showMsg();
    } else {
      hideMsg();
    }
  }

  var zipAttached = false;
  function attachZip() {
    if (zipAttached) return;
    var zipEl = getZipInput();
    if (!zipEl) return;
    zipAttached = true;
    zipEl.addEventListener('input', evaluateZip);
    zipEl.addEventListener('change', evaluateZip);
    evaluateZip();
  }

  // ---------------------------------------------------------------------------
  // Releasit Quantity Offers — variant enforcer
  // ---------------------------------------------------------------------------

  var PLACEHOLDER_ATTR = 'data-rsi-placeholder';
  var ERROR_CLASS      = '_rsi-variant-empty';
  var WARNING_CLASS    = '_rsi-variant-missing-warning';
  var SHOW_WARN_CLASS  = '_rsi-show-missing-warning';

  function injectStyle() {
    if (document.getElementById('_rsi-variant-enforcer-style')) return;
    var css =
      'select.' + ERROR_CLASS + '{' +
        'outline:2px solid #d33 !important;' +
        'outline-offset:1px !important;' +
        'box-shadow:0 0 0 3px rgba(221,51,51,.15) !important;' +
      '}' +
      '._rsi-quantity-offers .' + WARNING_CLASS + '{' +
        'display:none;margin:12px 0 4px;padding:10px 12px;' +
        'border-radius:8px;background:#fdecea;border:1px solid #f5c6c2;' +
        'color:#8a1f1f;font-size:13px;font-weight:600;text-align:center;' +
        'line-height:1.4;' +
      '}' +
      '._rsi-quantity-offers.' + SHOW_WARN_CLASS + ' .' + WARNING_CLASS + '{' +
        'display:block;' +
      '}';
    var style = document.createElement('style');
    style.id = '_rsi-variant-enforcer-style';
    style.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(style);
  }

  function placeholderLabelFor(select) {
    var container = select.closest('._rsi-quantity-offers-variant-selector-multi-sel-container');
    var name = container && container.querySelector('._rsi-quantity-offers-multi-sel-optname');
    var label = name ? (name.textContent || '').trim() : '';
    if (!label) label = 'opción';
    return 'Selecciona ' + label.toLowerCase();
  }

  function getAllOfferSelects() {
    return document.querySelectorAll(
      '._rsi-quantity-offers select[data-offer-num-multi-sel][data-option-num]'
    );
  }

  function clearPreselection(select) {
    if (!select || select.getAttribute(PLACEHOLDER_ATTR) === '1') return;

    // Strip any `selected` attribute Releasit pre-rendered onto the options.
    var opts = select.querySelectorAll('option');
    for (var i = 0; i < opts.length; i++) opts[i].removeAttribute('selected');

    // Prepend a disabled, selected placeholder as the default choice.
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.disabled = true;
    placeholder.selected = true;
    placeholder.setAttribute(PLACEHOLDER_ATTR, '1');
    placeholder.textContent = placeholderLabelFor(select);
    select.insertBefore(placeholder, select.firstChild);
    select.value = '';
    select.setAttribute(PLACEHOLDER_ATTR, '1');

    // Clear any pre-populated hidden variant id for this sub-item so Releasit
    // can't submit a stale variant the customer never chose.
    var subItem = select.closest('._rsi-quantity-offers-variant-selector-multi-sel');
    if (subItem) {
      var hidden = subItem.querySelector('input[type="hidden"][data-offer-num]');
      if (hidden) hidden.value = '';
    }

    select.addEventListener('change', function () {
      if (select.value) select.classList.remove(ERROR_CLASS);
      revalidateOffers();
    });
  }

  function setupSelects() {
    var selects = getAllOfferSelects();
    for (var i = 0; i < selects.length; i++) clearPreselection(selects[i]);
  }

  function getSelectedOfferContainer() {
    return document.querySelector(
      '._rsi-quantity-offers-offer-container._rsi-quantity-offers-selected'
    ) || document.querySelector('._rsi-quantity-offers-offer-container');
  }

  function getEmptySelectsInSelectedOffer() {
    var offer = getSelectedOfferContainer();
    if (!offer) return [];
    var selects = offer.querySelectorAll(
      'select[data-offer-num-multi-sel][data-option-num]'
    );
    var empties = [];
    for (var i = 0; i < selects.length; i++) {
      if (!selects[i].value) empties.push(selects[i]);
    }
    return empties;
  }

  function ensureWarning() {
    var wrap = document.querySelector('._rsi-quantity-offers');
    if (!wrap) return null;
    var warn = wrap.querySelector('.' + WARNING_CLASS);
    if (!warn) {
      warn = document.createElement('div');
      warn.className = WARNING_CLASS;
      warn.textContent =
        'Por favor, selecciona talla y color de todos los pares antes de continuar.';
      wrap.appendChild(warn);
    }
    return warn;
  }

  function revalidateOffers() {
    var wrap = document.querySelector('._rsi-quantity-offers');
    if (!wrap) return;
    ensureWarning();
    if (getEmptySelectsInSelectedOffer().length === 0) {
      wrap.classList.remove(SHOW_WARN_CLASS);
      var selects = getAllOfferSelects();
      for (var i = 0; i < selects.length; i++) selects[i].classList.remove(ERROR_CLASS);
    }
  }

  function variantsComplete() {
    return getEmptySelectsInSelectedOffer().length === 0;
  }

  function flagMissing() {
    var empties = getEmptySelectsInSelectedOffer();
    for (var i = 0; i < empties.length; i++) empties[i].classList.add(ERROR_CLASS);

    var wrap = document.querySelector('._rsi-quantity-offers');
    if (wrap && empties.length) {
      wrap.classList.add(SHOW_WARN_CLASS);
      if (empties[0].scrollIntoView) {
        try { empties[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        catch (e) { empties[0].scrollIntoView(); }
      }
    }
    return empties.length === 0;
  }

  function installSubmitGuards() {
    if (installSubmitGuards._done) return;

    // Use capture phase so we stop Releasit's own click handlers before they run.
    document.addEventListener('click', function (ev) {
      var target = ev.target;
      if (!target || !target.closest) return;

      var codBtn = target.closest('._rsi-build-block-submit-button');
      var advBtn = target.closest('a._rsi-buy-now-custom-additionals-button');
      if (!codBtn && !advBtn) return;

      // Only enforce when a quantity-offer block exists on the page.
      if (!document.querySelector('._rsi-quantity-offers')) return;

      if (!variantsComplete()) {
        ev.preventDefault();
        ev.stopPropagation();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        flagMissing();
      }
    }, true);

    installSubmitGuards._done = true;
  }

  // ---------------------------------------------------------------------------
  // Bootstrap
  // ---------------------------------------------------------------------------

  function tick() {
    attachZip();
    evaluateZip();
    setupSelects();
    ensureWarning();
  }

  function start() {
    injectStyle();
    installSubmitGuards();
    tick();

    new MutationObserver(tick).observe(document.body, {
      childList: true,
      subtree: true
    });

    // Fallback polling for the first ~20s in case the MutationObserver misses
    // a late-loading Releasit block (the app is lazy-loaded on some stores).
    var c = 0;
    var iv = setInterval(function () {
      tick();
      if (++c > 40) clearInterval(iv);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
